"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GanntEvent = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_konva_1 = require("react-konva");
var NEUTRAL_BORDER_COLOR = "transparent";
var HOVERED_BORDER_COLOR = "#edf2f7";
var SELECTED_BORDER_COLOR = "#2b6cb0";
var DRAGGED_BORDER_COLOR = "#2b6cb0";
var TEXT_X_AXIS_OFFSET = 12;
var TEXT_FONT_SIZE = 12;
var LINE_STROKE_THICKNESS = 2;
var STROKE_LENGTH = 5;
var STROKE_SPACE_APART = 7;
var DASH_SIZE = [STROKE_LENGTH, STROKE_SPACE_APART];
var GanntEvent = function (_a) {
    var id = _a.id, name = _a.name, background = _a.background, foreground = _a.foreground, _b = _a.width, width = _b === void 0 ? 0 : _b, _c = _a.height, height = _c === void 0 ? 0 : _c, _d = _a.x, x = _d === void 0 ? 0 : _d, _e = _a.y, y = _e === void 0 ? 0 : _e, selected = _a.selected;
    var _f = (0, react_1.useState)("Neutral"), eventState = _f[0], setEventState = _f[1];
    var hovered = eventState === "Hovered";
    var dragged = eventState === "Dragged";
    var strokeColor = selected
        ? SELECTED_BORDER_COLOR
        : hovered
            ? HOVERED_BORDER_COLOR
            : dragged
                ? DRAGGED_BORDER_COLOR
                : NEUTRAL_BORDER_COLOR;
    var dash = selected && !dragged ? DASH_SIZE : [];
    var lineX = x + LINE_STROKE_THICKNESS;
    var lineY = y + LINE_STROKE_THICKNESS;
    var rectX = lineX + 1;
    var rectY = lineY + 1;
    var textX = width + x + TEXT_X_AXIS_OFFSET;
    var textY = (height + LINE_STROKE_THICKNESS) / 2 - (TEXT_FONT_SIZE) / 2 + y;
    var points = [
        0, 0,
        width + LINE_STROKE_THICKNESS, 0,
        width + LINE_STROKE_THICKNESS, height + LINE_STROKE_THICKNESS,
        0, height + LINE_STROKE_THICKNESS // (x4, y4)
    ];
    var handleOnMouseOver = function () { return setEventState("Hovered"); };
    var handleOnDragStart = function () { return setEventState("Dragged"); };
    var handleOnDragEnd = function () { return setEventState("Neutral"); };
    var handleOnMouseLeave = function () { return setEventState(function (prev) { return prev === "Hovered" ? "Neutral" : prev; }); };
    return ((0, jsx_runtime_1.jsxs)(react_konva_1.Layer, __assign({ draggable: true, onDragStart: handleOnDragStart, onDragEnd: handleOnDragEnd, x: x, y: y }, { children: [(0, jsx_runtime_1.jsx)(react_konva_1.Line, { closed: true, tension: 0, stroke: strokeColor, strokeWidth: LINE_STROKE_THICKNESS, dash: dash, points: points, x: lineX, y: lineY }, void 0), (0, jsx_runtime_1.jsx)(react_konva_1.Rect, { id: id, x: rectX, y: rectY, fill: background, width: width, height: height, onMouseOver: handleOnMouseOver, onMouseLeave: handleOnMouseLeave }, void 0), (0, jsx_runtime_1.jsx)(react_konva_1.Text, { text: name, fontSize: TEXT_FONT_SIZE, fontStyle: "bold", x: textX, y: textY, fill: foreground }, void 0)] }), void 0));
};
exports.GanntEvent = GanntEvent;
